import React from "react";
import { Route, Switch } from "react-router-dom";
import LazyLoad from "../../../components/Common/LazyLoad";
import "./Dashboard/StateAdminDashboardStyles.scss";

const StateAdminDasboard = LazyLoad(() =>
  import("./Dashboard/StateAdminDashboard")
);
const StateAdminOrganizations = LazyLoad(() =>
  import("./Organizations/StateAdminOrganizations")
);

const StateAdminLayout = () => {
  return (
    // Navigation now comes from the shared AppShell sidebar (see Authmiddleware);
    // content fills the shell's content region.
    <div className="list-container fixed">
      <div className="state-admin admin-dashboard-wrapper" style={{ maxWidth: "100%" }}>
        <Switch>
          <Route
            exact
            path="/state-admin-dashboard"
            component={StateAdminDasboard}
          />
          <Route
            path="/state-admin-organizations"
            component={StateAdminOrganizations}
          />
        </Switch>
      </div>
    </div>
  );
};

export default StateAdminLayout;
